import { render, staticRenderFns } from "./ConfigShipping.vue?vue&type=template&id=0cbe63ca"
import script from "./ConfigShipping.vue?vue&type=script&lang=js"
export * from "./ConfigShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports